"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const translation_ar_json_1 = __importDefault(require("./translation-ar.json"));
const translation_bn_json_1 = __importDefault(require("./translation-bn.json"));
const translation_cs_json_1 = __importDefault(require("./translation-cs.json"));
const translation_da_json_1 = __importDefault(require("./translation-da.json"));
const translation_de_json_1 = __importDefault(require("./translation-de.json"));
const translation_en_json_1 = __importDefault(require("./translation-en.json"));
const translation_es_json_1 = __importDefault(require("./translation-es.json"));
const translation_fr_json_1 = __importDefault(require("./translation-fr.json"));
const translation_he_json_1 = __importDefault(require("./translation-he.json"));
const translation_hi_json_1 = __importDefault(require("./translation-hi.json"));
const translation_id_json_1 = __importDefault(require("./translation-id.json"));
const translation_it_json_1 = __importDefault(require("./translation-it.json"));
const translation_ja_json_1 = __importDefault(require("./translation-ja.json"));
const translation_kn_json_1 = __importDefault(require("./translation-kn.json"));
const translation_ko_json_1 = __importDefault(require("./translation-ko.json"));
const translation_ml_json_1 = __importDefault(require("./translation-ml.json"));
const translation_mr_json_1 = __importDefault(require("./translation-mr.json"));
const translation_nl_json_1 = __importDefault(require("./translation-nl.json"));
const translation_pl_json_1 = __importDefault(require("./translation-pl.json"));
const translation_pt_json_1 = __importDefault(require("./translation-pt.json"));
const translation_sv_json_1 = __importDefault(require("./translation-sv.json"));
const translation_ta_json_1 = __importDefault(require("./translation-ta.json"));
const translation_te_json_1 = __importDefault(require("./translation-te.json"));
const translation_th_json_1 = __importDefault(require("./translation-th.json"));
const translation_tr_json_1 = __importDefault(require("./translation-tr.json"));
const translation_zh_json_1 = __importDefault(require("./translation-zh.json"));
const translation_json_1 = __importDefault(require("./translation.json"));
// file-loader transforms JSON imports to resource URLs, so we cast our export accordingly here.
const i18nEndPointMap = {
    'translation-ar.json': translation_ar_json_1.default,
    'translation-bn.json': translation_bn_json_1.default,
    'translation-cs.json': translation_cs_json_1.default,
    'translation-da.json': translation_da_json_1.default,
    'translation-de.json': translation_de_json_1.default,
    'translation-en.json': translation_en_json_1.default,
    'translation-es.json': translation_es_json_1.default,
    'translation-fr.json': translation_fr_json_1.default,
    'translation-he.json': translation_he_json_1.default,
    'translation-hi.json': translation_hi_json_1.default,
    'translation-id.json': translation_id_json_1.default,
    'translation-it.json': translation_it_json_1.default,
    'translation-ja.json': translation_ja_json_1.default,
    'translation-kn.json': translation_kn_json_1.default,
    'translation-ko.json': translation_ko_json_1.default,
    'translation-ml.json': translation_ml_json_1.default,
    'translation-mr.json': translation_mr_json_1.default,
    'translation-nl.json': translation_nl_json_1.default,
    'translation-pl.json': translation_pl_json_1.default,
    'translation-pt.json': translation_pt_json_1.default,
    'translation-sv.json': translation_sv_json_1.default,
    'translation-ta.json': translation_ta_json_1.default,
    'translation-te.json': translation_te_json_1.default,
    'translation-th.json': translation_th_json_1.default,
    'translation-tr.json': translation_tr_json_1.default,
    'translation-zh.json': translation_zh_json_1.default,
    'translation.json': translation_json_1.default
};
exports.default = i18nEndPointMap;
